import React from 'react'

export default() => {
    return (
        <style>{`
   .input-first {
    padding-bottom: 21px;


}
.header-logo {
    width: 17%!important;
    margin-left: -5%;

}
.container.d-flex.flex-column.align-items-center.form {
    border: 2px solid #006a90;
    height: 1030px!important;
    width: 558px;
     margin-bottom: 357px;
    margin-top: -70px;
    box-shadow: 8px 17px #d6d6d6;

}

.div-container{
height: 70vh;
}
   .header-logo {
    height: 50%;
}
.img-form p{
    font-size:40px;
    color:white;

}
p.para1 {
    font-size: 17px;
    text-align: center;
}
.fields{
    width: 452px;
    padding-bottom: 10px;
}
    .text-area {
    width: 451px;
    padding-bottom: 30px;
}

.btn-form{
    width:395px;
    background-color:#f37f00;
}
.inside-form label{
    margin-top: 1rem;
}
.phone p{
margin-bottom:0!important;
}

   .label{
       color:black;
       font-weight: bold;
       margin-top: 2%;
       font-size: 24px;
       padding-left: 2%;
   }

   .ds{
       display:flex;

   }
   .span{
       color:black;
   }
   .container{
       width:50%;
       background-color: white;
       margin-top: 2%;
       height: 120vh;
       border-radius: 5px;
   }
   .container h1{
       color:black;



   }
   .contact{
       text-align: center;
       padding-top: 5%;
   }
   .line{
       text-align: center;
   }



   .btn_submit{
       width: 260px;
    border-radius: 21px;
    margin-top: 5%;
    padding: 10px;
    padding-left: 18px;
    padding-right: 18px;
    font-size: 24px;
    font-weight: bold;
    background-color: #F37F00;
    color: white;
   }
   .container {
    height: 120vh!important;
}
.mt-4{
margin-top:"1.5rem"!important;
margin-bottom: 30px;
}

   `}</style>
    );
}